import { makeStyles } from '@material-ui/core';
import { useRef } from 'react';
import '../../../assets/styles/blink.css'
import useHover from '../../../hooks/useHover';
import { v4 as uuidv4 } from 'uuid';
import { IAlreadyBooked } from '../../../interface/interface';

interface Props {
    alreadyBookings: IAlreadyBooked[];
    eaterGroupName: string;
    eaterGroupBookings: IAlreadyBooked[];
}

const useStyles = makeStyles((theme: any) => ({
    container:{
        position: 'relative',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        cursor: 'pointer',
    },
    bookingsContainer: {
        position: 'absolute',
        minWidth: '275px',
        zIndex: 2,
        background: 'white',
        color: 'black',
        border: '1px solid grey',
        padding: 8,
        top: '80%',
        bottom: 'auto',
        right: '-10px',
        borderRadius: 8,
        animation: 'fadeIn 0.3s',

        '&::after': {
            content:"''",
            position: 'absolute',
            right: '100%',
            left: '89%',
            top: -16,
            borderWidth: 8,
            borderStyle: 'solid',
            borderColor: 'transparent transparent grey transparent'
        },

        '& > *': {
            display: 'grid',
            justifyContent: 'start',
            gridTemplateColumns: "100%",
            marginBottom: 10
        }
    },
}));


export const AlreadyBookedBatch: React.FC<Props> = ({ alreadyBookings, eaterGroupName, eaterGroupBookings }) => {
    const classes = useStyles();
    const hoverRef = useRef(null)
    const isHover = useHover(hoverRef)

    

    return ( 
      <div ref={hoverRef} className={classes.container}>
          <div hidden={!isHover}> 
                <div className={classes.bookingsContainer}>
                    {
                        alreadyBookings.length > 0 ?
                        <div>                        
                            <b>You are already booked at:</b>
                            <div>
                                {
                                    alreadyBookings.map(alreadyBooking => (
                                        <div key={uuidv4()}>
                                            {alreadyBooking.quantity} x {alreadyBooking.seatingName} {alreadyBooking.seatingTime} - {alreadyBooking.officeName}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        :
                        <b>You are not booked for today</b>
                    }
                    {
                        eaterGroupBookings.length > 0 ?
                        <div>
                           <b>{eaterGroupName} is booked at:</b>
                           <div>
                                {
                                    eaterGroupBookings.map(eaterGroupBooking => (
                                        <div key={uuidv4()}>
                                            {eaterGroupBooking.quantity} x {eaterGroupBooking.seatingName} - {eaterGroupBooking.seatingTime}
                                        </div>
                                    ))
                                }
                            </div>
               
                        </div>
                        :
                        <b></b>
                    }
                </div>
          </div>
          <div className='blink' style={{ backgroundColor: alreadyBookings.length > 0 ? "#6178ed" : "#999999" }} />
      </div>
    );
}